import { MeetingDocument } from '../../../graphql/react-operations';
import {
  GqlBolagoFile,
  GqlMeeting,
  GqlMeetingStatus,
  GqlMeetingValidatorErrors,
} from '../../../graphql/base-types.graphql';
import { MeetingAttendanceList } from './AttendanceList';
import { Card } from '@startuptools/ui/Card';
import { Divider } from '@startuptools/ui/Divider';
import { Stack } from '@startuptools/ui/Stack';
import { MeetingSummonsDocument } from '../../common/components/documents/MeetingSummons';
import { useApolloClient } from '@apollo/client';
import { ParticipantsSummons } from './edit-steps/ParticipantsSummons';
import { BoardMeetingDocument } from '../../board-meetings/BoardMeeting.graphql';
import { ShareholdersMeetingDocument } from '../../shareholders-meetings/ShareholdersMeeting.graphql';

export const MeetingParticipantsShow = ({
  meeting,
  meetingErrors,
}: {
  meeting: Pick<GqlMeeting, 'id' | 'status' | 'number' | 'startTime' | 'kind'> & {
    latestSummonsDocument?: Pick<GqlBolagoFile, 'id'> | null;
  };
  meetingErrors: GqlMeetingValidatorErrors;
}) => {
  const apolloClient = useApolloClient();

  return (
    <>
      {meeting.status === GqlMeetingStatus.Finished ? (
        <MeetingAttendanceList meetingId={meeting.id} />
      ) : (
        <Card>
          <Stack gap={3}>
            <MeetingSummonsDocument
              meeting={meeting}
              refetch={() =>
                apolloClient.refetchQueries({
                  include: [BoardMeetingDocument, ShareholdersMeetingDocument, MeetingDocument],
                })
              }
            />
            <Divider />
            <ParticipantsSummons
              meetingId={meeting.id}
              documentId={meeting.latestSummonsDocument?.id}
              errors={meetingErrors}
            />
          </Stack>
        </Card>
      )}
    </>
  );
};
